var _excluded = ["numberOfChildren", "cols"],
    _excluded2 = ["children", "legend", "hideLegend"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { shouldForwardProp } from '../../utils';
import { strictSpace } from '../../utils';
import { Legend } from '../..';
export var ChoicePadHidden = styled.label.withConfig({
  displayName: "ChoiceGroup__ChoicePadHidden",
  componentId: "sc-xs4qql-0"
})(["visibility:hidden;width:10em;margin:0 ", ";border:2px solid;box-sizing:border-box;user-select:none;flex-basis:10em;flex-grow:1;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.space.xxs;
}, strictSpace);
export var StyledChoiceGroup = styled.fieldset.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "ChoiceGroup__StyledChoiceGroup",
  componentId: "sc-xs4qql-1"
})(["max-width:", ";", ""], function (_ref2) {
  var width = _ref2.width;
  return width;
}, strictSpace);
export var ChoiceGrid = styled.div.withConfig({
  displayName: "ChoiceGroup__ChoiceGrid",
  componentId: "sc-xs4qql-2"
})(["display:flex;flex-wrap:wrap;justify-content:space-between;margin:-", ";> button,label{flex-basis:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.xxs;
}, function (_ref4) {
  var width = _ref4.width,
      cols = _ref4.cols;
  return "calc(".concat(width, " / ").concat(cols, ")");
});
export var HiddenChoicePads = function HiddenChoicePads(_ref5) {
  var numberOfChildren = _ref5.numberOfChildren,
      cols = _ref5.cols,
      props = _objectWithoutProperties(_ref5, _excluded);

  var numberChoicePadHidden = cols - numberOfChildren % cols;
  var iterations = numberChoicePadHidden ? _toConsumableArray(Array(numberChoicePadHidden).keys()) : [];
  return iterations.length ? iterations.map(function (number) {
    return /*#__PURE__*/React.createElement(ChoicePadHidden, {
      key: number
    });
  }) : null;
};
export var ChoiceGroup = function ChoiceGroup(_ref6) {
  var children = _ref6.children,
      legend = _ref6.legend,
      hideLegend = _ref6.hideLegend,
      props = _objectWithoutProperties(_ref6, _excluded2);

  return /*#__PURE__*/React.createElement(StyledChoiceGroup, props, /*#__PURE__*/React.createElement(Legend, {
    screenReaderOnly: hideLegend,
    mb: "s"
  }, legend), /*#__PURE__*/React.createElement(ChoiceGrid, {
    width: props.width,
    cols: props.cols + 1
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, props);
  }), /*#__PURE__*/React.createElement(HiddenChoicePads, {
    numberOfChildren: children.length,
    cols: props.cols
  })));
};
ChoiceGroup.propTypes = {
  legend: PropTypes.string.isRequired,
  hideLegend: PropTypes.bool,
  cols: PropTypes.number
};
ChoiceGroup.defaultProps = {
  hideLegend: false,
  cols: 2,
  width: '100%'
};
export default ChoiceGroup;